import { createApp } from 'vue'
import { createPinia } from 'pinia'

// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import '@mdi/font/css/materialdesignicons.css'

// Estilos customizados
import '@/assets/styles/main.scss'

import App from './App.vue'

// Configuração do Vuetify
const vuetify = createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi
    }
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        dark: false,
        colors: {
          primary: '#2563EB',
          secondary: '#64748B',
          accent: '#3B82F6',
          error: '#EF4444',
          info: '#3B82F6',
          success: '#22C55E',
          warning: '#F59E0B',
          background: '#F1F5F9',
          surface: '#FFFFFF',
          'on-background': '#1E293B',
          'on-surface': '#1E293B'
        }
      }
    }
  },
  defaults: {
    VCard: {
      elevation: 0
    },
    VBtn: {
      elevation: 0
    },
    VTextField: {
      variant: 'outlined',
      density: 'comfortable'
    },
    VSelect: {
      variant: 'outlined',
      density: 'comfortable'
    }
  }
})

// Criar aplicação
const app = createApp(App)

// Usar plugins
app.use(createPinia())
app.use(vuetify)

// Montar aplicação
app.mount('#app')
